
<style lang="scss" scoped>
.bread-title {
    font-size: 30px;
    color: #666;
}
.bread-subtitle {
    line-height: 3;
    background-color: #f7f7f7;
    padding-left: 15px;
    margin: 5px 0 15px;
}
</style>

<template>
    <div class="bread">
        <h3>
            <span class="bread-title">{{title}}&nbsp;</span>{{title}}
        </h3>
        <Breadcrumb class="bread-subtitle">
            <BreadcrumbItem to="/panel">{{home||'主面板'}}</BreadcrumbItem>
            <BreadcrumbItem>{{title}}</BreadcrumbItem>
        </Breadcrumb>
    </div>
</template>

<script>
export default {
    props: ['title', 'home'],
};
</script>

